export class NumberFormat {
    format: string;
    ticksCount: number;

    constructor() {
        this.format = '';
        this.ticksCount = 6;
    }
}